(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["tba-popup"]) return;
  try {
    
  jQuery(document).ready(function() {
    jQuery('#popup-submit').bind('click', function(event) {
        if (event) {
            event.preventDefault();
        }
        if (validatepopupform()) {
            registerpopuppage(jQuery('#popup-form'));
        }
    })
  });

  function validatepopupform() {
    var requiredcheck = true;
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var emailcheck = regex.test(jQuery('#popup-email').val());
    jQuery('.popup-required').each(function(){
      if(jQuery(this).val() == ''){
          requiredcheck = false;
      }	
    })
    jQuery('.popup-error').remove();
    if (!emailcheck) {
        jQuery('#popup-form').append("<span class='popup-error'>Please enter a valid email address!</span>");
    }
    if (emailcheck && !requiredcheck) {
        jQuery('#popup-form').append("<span class='popup-error'>Please fill out all required fields!</span>");
    }

    if (emailcheck && requiredcheck) {
        return true;
    } else {
        return false;
    }
  }

  function registerpopuppage(form) {
    jQuery.ajax({
        type: form.attr('method'),
        url: form.attr('action'),
        data: form.serialize(),
        cache: false,
        dataType: 'jsonp',
        contentType: "application/json; charset=utf-8",
        error: function(err) {
            jQuery('.popup-error').remove();
            jQuery('#popup-form').append("<span class='popup-error'>Could not register you. Please try again later.</span>");
        },
        success: function(data) {
            if (data.result != "success") {
                jQuery('#popup-form').append(data.msg);
            } else {
                jQuery('#popup-form').css('display', 'none');
                //jQuery('#popup-form').after('<h3>' + data.msg + '</h3>');
                jQuery('#popup-form').after(jQuery('#popup-success-message').val());
            }
        }
    })
  }

  } catch(e) { console.error(e); }
})();

})();
